export enum OrbitRemoveOwnerStep {
  CONFIRM_SELF_REMOVAL,
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  REMOVED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  REJECTED_BY_THE_USER,
}
